/**
 * Compact ReadBuddy header mark used on every authenticated screen
 * (Home, Books, Reading, Dashboard, Profile) for consistent branding.
 *
 * Iter-51.12: swapped from a `BookOpen` lucide icon + text lockup to
 * the real R+B monogram (soundwave + open book) rendered as an image.
 * The wordmark stays as HTML text so it remains crisp at every DPR
 * and picks up the same blue→purple gradient the mark uses.
 *
 * The illustrated full-lockup logo (with tagline "Your Reading. Your
 * Buddy." and "Read • Practice • Progress" sub-tagline) still lives
 * only on the Login screen — see `pages/Login.jsx`.
 */
export default function BrandMark({ className = '', size = 'md' }) {
  const sizes = {
    sm: { box: 'w-7 h-7', text: 'text-base' },
    md: { box: 'w-9 h-9', text: 'text-lg' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div data-testid="brand-mark" className={`inline-flex items-center gap-2 select-none ${className}`}>
      <img
        data-testid="brand-mark-icon"
        src="/assets/readbuddy-icon-192.png"
        alt="ReadBuddy"
        width={192}
        height={192}
        className={`${s.box} object-contain`}
        loading="eager"
        decoding="async"
      />
      <span className={`font-extrabold tracking-tight ${s.text}`}>
        {/* Text lockup matches the artwork's gradient: navy → royal blue → purple. */}
        <span className="text-[#1E1B4B]">Read</span>
        <span className="bg-gradient-to-r from-[#2563EB] to-[#7C3AED] bg-clip-text text-transparent">Buddy</span>
      </span>
    </div>
  );
}
